import { render, staticRenderFns } from "./projectInfoForm.vue?vue&type=template&id=68bd34db&scoped=true&"
import script from "./projectInfoForm.vue?vue&type=script&lang=js&"
export * from "./projectInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bd34db",
  null
  
)

export default component.exports